module.exports = __webpack_public_path__ + "static/media/on-eye_classic-Vivid.cfddb5c2.jpg";